module.exports = __webpack_public_path__ + "static/img/pan.180eae1e.png";